module.exports = __webpack_public_path__ + "4afb696a72a6ebcc888417e873a52c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/close.png
// module id = 744
// module chunks = 0